import { OnboardingWalletBackComponent } from '../onboarding-wallet-back/onboarding-wallet-back.component';
import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { OnboardingWalletFrontComponent } from '../onboarding-wallet-front/onboarding-wallet-front.component';
import { MapfreModalComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input } from "@angular/core";
import { ModalOptions } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreModalComponent, OnboardingWalletFrontComponent, MapfreButtonComponent, OnboardingWalletBackComponent],
  selector: "app-onboarding-wallet-modal",
  templateUrl: "./onboarding-wallet-modal.component.html",
  styleUrls: ["./onboarding-wallet-modal.component.scss"],
})
export class OnboardingWalletModalComponent {
  @Input() policyNumber: string;
  hideModal = false;
  onClickEventWalletPass = false;
  walletDownloadModalOptions: ModalOptions;

  constructor() {
    this.walletDownloadModalOptions = new ModalOptions({
      additionalButtonClasses:
        "ghost primary xsmall full no-margin float-right width w160",
      additionalClasses:
        "modal-dialog center-on-page wallet-popup modal-medium",
      animatePosition: "bottom",
      buttonCopy: "DOWNLOAD",
      modalId: "helpModal",
      modalTranslateCopy: "MODAL_WHERE_CAN_I_TITLE",
      typeOfModal: "wallet",
      onLoad: false,
      modalName: "wallet_Download",
    });
  }

  goToWalletPassModal(event): void {
    if (event) {
      this.onClickEventWalletPass = !this.onClickEventWalletPass;
    }
  }

  hideModalAction(event): void {
    if (event) {
      this.hideModal = !this.hideModal;
    }
    setTimeout(() => {
      this.hideModal = false;
    }, 500);
  }

}
